import { AppState } from '../../store';

export const getH5Details = (state: AppState) => state.h5;
